import { TErrorComponent } from "../../types";

const ErrorComponent = ({ errorMessage }: TErrorComponent) => {
  return <div className='font-bold text-center text-red-500'>{errorMessage}</div>;
};

export default ErrorComponent;